import Repository from './Repository';


const baseUrl = process.env.VUE_APP_API_URL;
const base = `${baseUrl}/chapter`;

export default {
  /**
   * Renames the given Chapter / Entry
   *
   * @param id
   * @param title
   * @param subId
   * @returns {Promise<AxiosResponse<T>>}
   */
  renameChapter(id, title, subId = null) {
    return Repository.post(`${base}/rename`, {
      id,
      title,
      subid: subId,
    });
  },

  /**
   * Adds a new chapter or subchapter to the Instance.
   *
   * @param title
   * @param parentChapterId
   * @returns {Promise<AxiosResponse<T>>}
   */
  addChapter(title, parentChapterId = null) {
    return Repository.post(`${base}/add`, {
      title,
      id: parentChapterId,
    });
  },

  /**
   * Removes chapter or subchapter from the instance.
   * @param id
   * @param subId
   * @returns {Promise<AxiosResponse<T>>}
   */
  delete(id, subId = null) {
    return Repository.post(`${base}/delete`, {
      id,
      subid: subId,
    });
  },

  /**
   * Moves the given chapter or subchapter inside of the instance.
   *
   * @param id
   * @param subid
   * @param target
   * @param position
   * @returns {Promise<AxiosResponse<T>>}
   */
  move(id, subid, target, position) {
    return Repository.post(`${base}/move`, {
      id,
      subid,
      target,
      position,
    });
  },

  timeShift(timestamp, chapter_start_id, chapter_end_id, entry_start_id = null, entry_end_id = null) {
    return Repository.post(`${base}/timeshift`, {
      timestamp,
      start_id: chapter_start_id,
      end_id: chapter_end_id,
      start_subid: entry_start_id,
      end_subid: entry_end_id,
    });
  },


  appendEntryWithMember(channelId, entryId, groupId, memberId) {
    return Repository.post(`${base}/append`, {
      chid: channelId,
      subid: entryId,
      gid: groupId,
      id: memberId,
    });
  },

  appendEntryWithEvent(channelId, entryId, eventId) {
    return Repository.post(`${base}/append`, {
      chid: channelId,
      subid: entryId,
      eid: eventId
    });
  }
};
